export default `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAnBpe3rgBz74CmxVNf4Er
eTF6QZeIU4pgTXYbcERNC1BIN1tMuPbUmGUZKkyLbmBCdYNH8P3M20yPewTPvWNI
vwN8rLMblwXmADwMFgynhiJTQbba3mHLmMA9LyhvTU4bBpYg+JRcCKsh4DM6Uto2
CX62Y276aJoOkqOun4VeHxBYy7x8Ds8gHiZ8KzoneDUNmGqEvEQpcntM/geyF4TO
3Xf0HfEifwyKtilq5DTDGucnwy1Tsbl0Q+fgVLy5NUVFBY34O1azmwJvrvhwudpN
DeiJ5s66RiO/f7yFLRQeOs9RTOAimHa3hRgsRyjiafh++5qsMcPBDg80VNJzYHd5
+wIDAQAB
-----END PUBLIC KEY-----`;